import script from "./QA.vue?vue&type=script&setup=true&lang=js"
export * from "./QA.vue?vue&type=script&setup=true&lang=js"

import "./QA.vue?vue&type=style&index=0&id=c4e67db4&lang=scss"

const __exports__ = script;

export default __exports__